import { createTheme } from "@material-ui/core";

// Material-UI Theme (MuiTheme)
// https://material-ui.com/customization/theming/
// All the following keys are optional, as default values are provided.
// https://material-ui.com/customization/palette/

// Default Theme
// https://material-ui.com/customization/default-theme/

// ******************
// Color Tool von Material
// https://material.io/resources/color/#!/?view.left=1&view.right=1&primary.color=cce4f0&secondary.color=EEBBEE&primary.text.color=007bc6
// ******************
const theme = createTheme({
    // #FF9901 orange
    palette: {
        primary: { main: '#0063ba' }, // blau #007bc6
        secondary: { main: '#237855' }, //gruen #00a876 
        text: {
            primary: '#0063ba', // Vorgabe: #007bc6 blau,   rgb(0,80,149, .84)
            secondary: 'white'
        },
        error: {
            main: '#a90000'// https://gist.github.com/lopspower/03fb1cc0ac9f32ef38f4 
        }
    },

    typography: {
        h1: {
            fontFamily: ['"Raleway"', 'sans-serif'].join(','),
            fontSize: 40
        },
        h2: {
            fontFamily: ['"Raleway"', 'sans-serif'].join(','),
            fontSize: 36
        },
        h3: {
            fontFamily: ['"Raleway"', 'sans-serif'].join(','),
            fontSize: 32
        },
        h4: {
            fontFamily: ['"Raleway"', 'sans-serif'].join(','),
            fontSize: 26
        },
        h5: {
            fontFamily: ['"Raleway"', 'sans-serif'].join(','),
            fontSize: 20
        },
        h6: {
            fontFamily: ['"Raleway"', 'sans-serif'].join(','),
            fontSize: 14,
        },
        body1: {
            fontFamily: ['"Roboto-300"', 'sans-serif'].join(','),
            fontSize: 18,
            letterSpacing: 0.5
        },
        body2: {
            fontFamily: ['"Roboto-300"', 'sans-serif'].join(','),
            fontSize: 14,
            letterSpacing: 0.5
        },
        subtitle1: {
            fontFamily: ['"Roboto-700"', 'sans-serif'].join(','),
            letterSpacing: 2.5,
            fontSize: 20,
        },
        subtitle2: {
            fontFamily: ['"Roboto-700"', 'sans-serif'].join(','),
            letterSpacing: 2.5,
            fontSize: 14,
        },
        caption: {
            fontFamily: ['"Roboto-300"', 'sans-serif'].join(','),
            fontSize: 13,
        }
        ,
        fontFamily: ['"Roboto-400"', 'sans-serif'].join(','),

        /*
        h2: {
            fontSize: 19
        }
        */
    }
});


console.log('theme', theme);
export default theme;